<template>
    <div class="fileDetail">
        <el-button size="mini" icon="el-icon-arrow-left" @click="backToList">
            {{ $translate('lang.E3202101260028', { defaultText: '返回' }) }}
        </el-button>
        <h4>
            {{ $translate('lang.E3202101260029', { defaultText: '档案详情' }) }}
        </h4>
        <el-row class="detailContent">
            <el-col
                :span="12"
                v-for="(item, index) in columns"
                :key="index"
                class="itemColumn">
                <el-tooltip
                    effect="dark"
                    placement="top"
                    :content="item.label"
                    :disabled="
                        newCloums[index] && newCloums[index].isLabelShow
                    ">
                    <div class="label">
                        <span :id="`${item.prop}Label`">{{ item.label }}</span>
                    </div>
                </el-tooltip>
                <el-tooltip
                    effect="dark"
                    :content="data[item.prop]"
                    :disabled="newCloums[index] && newCloums[index].isValueShow"
                    placement="top">
                    <div class="value">
                        <span :id="`${item.prop}Value`">
                            {{ data[item.prop] }}
                        </span>
                    </div>
                </el-tooltip>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    props: {
        data: {
            type: Object,
            default: () => {
                return {};
            }
        },
        columns: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            newCloums: []
        };
    },
    watch: {
        data: {
            immediate: true,
            handler(newVal) {
                this.$nextTick(() => {
                    this.newCloums = this.columns.map((item) => {
                        item.isLabelShow = this.computedShow(
                            `${item.prop}Label`
                        );
                        item.isValueShow = this.computedShow(
                            `${item.prop}Value`
                        );
                        return item;
                    });
                });
            }
        }
    },
    methods: {
        backToList() {
            this.$emit('backToList');
        },
        computedShow(str) {
            const node = document.querySelector(`#${str}`);
            const parentWidth = node.parentNode.offsetWidth;
            const contentWidth = node.offsetWidth;
            return contentWidth < parentWidth - 50;
        }
    }
};
</script>
<style lang="less" scoped>
h4 {
    margin-top: 20px;
    color: #333333;
    font-size: 16px;
}
.fileDetail {
    .detailContent {
        width: 100%;
        margin-top: 15px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        border-right: 1px solid rgba(0, 0, 0, 0.06);
        .itemColumn {
            display: flex;
            height: 44px;
            border-top: 1px solid rgba(0, 0, 0, 0.06);
            border-left: 1px solid rgba(0, 0, 0, 0.06);
            line-height: 44px;
        }
        .label {
            padding: 0 23px;
            width: 100px;
            border-radius: 4px 0px 0px 4px;
            background: rgba(0, 0, 0, 0.02);
            font-size: 14px;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.85);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .value {
            padding: 0 23px;
            border-left: 1px solid rgba(0, 0, 0, 0.06);
            width: 100%;
            font-size: 14px;
            color: #333333;
            padding: 1px 0 0 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: middle;
        }
        .el-tooltip__popper.is-dark {
            max-width: 600px;
            background: #546371;
            color: #ffffff;
        }
        .el-tooltip__popper[x-placement^='top'] .popper__arrow:after {
            border-top-color: #546371;
        }
    }
}
</style>
